import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';

const V2Investors = () => {
  useSEO({
    title: 'Investors — Keystone Strategic Consultants',
    description: 'Confidential information for approved investors and strategic partners. Detailed commercial, product and investment information is available through our secure Investor Portal.',
    path: '/investors',
    noindex: true,
  });

  return (
    <div data-testid="v2-investors">
      <ProductHero
        eyebrow="Keystone Strategic Consultants · Investors"
        title="Turning real-world expertise into scalable technology."
        body={(
          <>
            <p>Keystone Strategic Consultants is the company behind Videra — a growing ecosystem of digital platforms designed around project delivery, lifecycle management, operational assurance and evidence.</p>
            <p>Videra originated from practical experience within complex UK healthcare, PFI, Hard Services and construction environments.</p>
            <p>Today, Keystone is developing that experience into a scalable technology proposition spanning specialist sector platforms, configurable project delivery, PFI/P3 assurance and passive fire protection.</p>
          </>
        )}
        testid="investors-hero"
      />

      <section className="py-16 md:py-20 bg-slate-50 border-y border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">From experience to technology</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 max-w-3xl">
            Domain experience → methodology → technology → repeatable products → multi-sector scale.
          </h2>
          <p className="mt-6 text-slate-700 leading-relaxed">
            We don&rsquo;t identify a software market and then try to understand its operational problems. We start
            with problems experienced in real delivery environments and build practical technology around solving them.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24" data-testid="investors-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">Investment & Strategic Partnerships</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900">Discuss the opportunity.</h2>
          <p className="mt-6 text-slate-700 leading-relaxed max-w-3xl">
            Keystone is open to conversations with investors and strategic partners who understand the opportunity to scale specialist B2B technology built around complex real-world operational problems.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed max-w-3xl">
            Detailed commercial, product and investment information is available through our secure Investor Portal.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to="/contact" className="inline-flex items-center gap-2 bg-slate-900 text-white px-7 py-3.5 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-testid="investors-request">
              Request Investor Access <ArrowRight className="w-4 h-4" />
            </Link>
            <button
              disabled
              className="inline-flex items-center gap-2 border border-slate-300 text-slate-500 px-7 py-3.5 rounded-md text-sm font-medium cursor-not-allowed"
              data-testid="investors-login"
            >
              <Lock className="w-4 h-4" /> Investor Login (coming soon)
            </button>
          </div>
          <p className="mt-8 text-xs text-slate-500 leading-relaxed max-w-3xl">
            Information on this page is provided for general information only and does not constitute an offer or invitation to purchase securities or investment advice.
          </p>
        </div>
      </section>
    </div>
  );
};

export default V2Investors;
